import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LegalPageLayoutComponent, LegalSection } from '../../../components/legal/legal-page-layout/legal-page-layout';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [LegalPageLayoutComponent, RouterLink],
  templateUrl: './privacy-policy.html',
})
export class PrivacyPolicy {
  sections: LegalSection[] = [
    { id: 'definitions', label: 'Definitions' },
    { id: 'uk-gdpr-compliance', label: 'UK GDPR Compliance' },
    { id: 'information-we-collect', label: 'Information We Collect' },
    { id: 'how-we-use-your-information', label: 'How We Use Your Information' },
    { id: 'legal-bases', label: 'Legal Bases for Processing Personal Information' },
    { id: 'sharing-your-information', label: 'Sharing Your Information' },
    { id: 'international-transfers', label: 'International Data Transfers' },
    { id: 'security-of-your-information', label: 'Security of Your Information' },
    { id: 'data-retention', label: 'Data Retention' },
    { id: 'your-rights', label: 'Your Rights Under UK GDPR' },
    { id: 'law-enforcement-requests', label: 'Law Enforcement & Regulatory Requests' },
    { id: 'marketing-communications', label: 'Marketing Communications' },
    { id: 'changes-to-this-policy', label: 'Changes to this Privacy Policy' },
    { id: 'contact-us', label: 'Contact Us' },
    { id: 'our-commitment', label: 'Our Commitment to Privacy, Consent & Community Safety' },
  ];
}
